import type { JSX } from 'react';
import { useEffect, useState } from 'react';
import { EyeOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';

import { exitPreview, isPreviewMode, previewReturnUrl, syncPreviewFromUrl } from '../lib/preview';

/**
 * Плашка вкладки предпросмотра черновика курса: «результаты не
 * сохраняются» + «Вернуться в редактор» (вкладку открыл конструктор —
 * закрываем её; не вышло — переходим в редактор) и «Выйти из предпросмотра».
 *
 * Стоит в липком верху оболочки (Layout, `.fk-hub-top`) сразу под шапкой,
 * как плашка «от лица партнёра». Раньше была внутри страницы с top: 0 и
 * при прокрутке наезжала на шапку (владелец 12.10.2026).
 */
export function PreviewBanner(): JSX.Element | null {
  const location = useLocation();
  const [on, setOn] = useState(isPreviewMode);
  useEffect(() => {
    syncPreviewFromUrl(location.search);
    setOn(isPreviewMode());
  }, [location.search, location.pathname]);
  if (!on) return null;
  const back = (): void => {
    const url = previewReturnUrl();
    exitPreview();
    window.close();
    // Вкладку открыли не скриптом — закрыть нельзя: просто идём в редактор.
    window.setTimeout(() => window.location.assign(url), 150);
  };
  return (
    <div className="fk-hub-preview" role="status">
      <EyeOutlined className="fk-hub-viewas-ic" />
      <span className="fk-hub-viewas-text">
        <b>Предпросмотр черновика</b> — результаты не сохраняются.
        <span className="fk-hub-preview-more"> Так курс увидит сотрудник после публикации.</span>
      </span>
      <button type="button" className="fk-btn fk-btn-primary fk-btn-sm" onClick={back}>Вернуться в редактор</button>
      <button
        type="button"
        className="fk-btn fk-btn-subtle fk-btn-sm"
        aria-label="Выйти из предпросмотра"
        onClick={() => {
          exitPreview();
          setOn(false);
          window.location.assign('/education');
        }}
      >
        Выйти<span className="fk-hub-preview-more"> из предпросмотра</span>
      </button>
    </div>
  );
}
